// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* RegisterEmpresa.module.css */

/* ── Página ── */
.RegisterEmpresa_page__cPRB5 {
  min-height: 100vh;
  background-color: #f0f4f8;
  padding-top: 64px;
}

/* ── Header superior ── */
.RegisterEmpresa_pageHeader__uK0dP {
  background: #ffffff;
  border-bottom: 1px solid #e4e7ec;
  padding: 16px 20px 16px;
}

.RegisterEmpresa_headerInner__M9f45 {
  max-width: 900px;
  margin: 0 auto;
}

.RegisterEmpresa_breadcrumb__yNe9f {
  font-size: 13px;
  color: #98a2b3;
  margin-bottom: 10px;
}

.RegisterEmpresa_breadcrumb__yNe9f a {
  color: #98a2b3;
  text-decoration: none;
}

.RegisterEmpresa_breadcrumb__yNe9f span {
  color: #344054;
  font-weight: 500;
}

.RegisterEmpresa_headerRow__V4WPv {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.RegisterEmpresa_headerLeft__u2wiS h1 {
  font-size: 2rem;
  font-weight: 700;
  color: #1a3a5c;
  margin: 0 0 4px;
}

.RegisterEmpresa_headerLeft__u2wiS p {
  font-size: 14px;
  color: #667085;
  margin: 0;
}

.RegisterEmpresa_loginHint__JV92z {
  font-size: 14px;
  color: #667085;
  white-space: nowrap;
}

.RegisterEmpresa_loginHint__JV92z a {
  color: #1a3a5c;
  font-weight: 600;
  text-decoration: none;
}

.RegisterEmpresa_loginHint__JV92z a:hover {
  text-decoration: underline;
}

/* ── Stepper ── */
.RegisterEmpresa_stepper__jn-th {
  display: flex;
  align-items: center;
  gap: 0;
  margin-top: 24px;
}

.RegisterEmpresa_stepItem__PM8Eb {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #98a2b3;
  font-weight: 500;
}

.RegisterEmpresa_stepItem__PM8Eb.RegisterEmpresa_active__NtK5k {
  color: #1a3a5c;
  font-weight: 600;
}

.RegisterEmpresa_stepCircle__GPQNC {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 2px solid #d0d5dd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #98a2b3;
  background: #fff;
  flex-shrink: 0;
}

.RegisterEmpresa_stepItem__PM8Eb.RegisterEmpresa_active__NtK5k .RegisterEmpresa_stepCircle__GPQNC,
.RegisterEmpresa_stepItem__PM8Eb.RegisterEmpresa_done__Btv-7 .RegisterEmpresa_stepCircle__GPQNC {
  background: #2db899;
  border-color: #2db899;
  color: #fff;
}

.RegisterEmpresa_stepLine__MPxiZ {
  width: 80px;
  height: 2px;
  background: #d0d5dd;
  margin: 0 8px;
}

/* ── Contenido central ── */
.RegisterEmpresa_content__U7hVA {
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
  box-sizing: border-box;
}

/* ── Card del formulario ── */
.RegisterEmpresa_card__xc729 {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 36px 40px;
  box-sizing: border-box;
}

.RegisterEmpresa_stepLabel__YjZU7 {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  color: #2db899;
  margin-bottom: 6px;
}

.RegisterEmpresa_cardTitle__9Hho\\+ {
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a3a5c;
  margin-bottom: 4px;
}

.RegisterEmpresa_cardSubtitle__fT-Qc {
  font-size: 13px;
  color: #667085;
  margin-bottom: 28px;
}

/* ── Grid del formulario ── */
.RegisterEmpresa_formGrid__UmiUb {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px 16px;
  margin-bottom: 28px;
}

.RegisterEmpresa_formGrid2__2\\+5BX {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 16px;
  margin-bottom: 28px;
}

.RegisterEmpresa_field__5dRL- {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.RegisterEmpresa_fieldFull__NCfXd {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.RegisterEmpresa_label__mAIss {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #667085;
}

.RegisterEmpresa_input__aB2MZ {
  height: 40px;
  padding: 0 12px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  font-size: 14px;
  color: #344054;
  background: #ffffff;
  outline: none;
  width: 100%;
  box-sizing: border-box;
  transition: border-color 0.2s;
  font-family: inherit;
}

.RegisterEmpresa_input__aB2MZ:focus {
  border-color: #1a3a5c;
}

.RegisterEmpresa_input__aB2MZ::placeholder {
  color: #b0b8c4;
}

/* ── Nota obligatorios ── */
.RegisterEmpresa_required__SNnlZ {
  font-size: 12px;
  color: #98a2b3;
  margin-bottom: 28px;
}

/* ── Checkbox ── */
.RegisterEmpresa_checkRow__9J1DJ {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #344054;
}

.RegisterEmpresa_checkRow__9J1DJ input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: #2db899;
  cursor: pointer;
  flex-shrink: 0;
}

.RegisterEmpresa_checkRow__9J1DJ a {
  color: #2db899;
  font-weight: 600;
  text-decoration: none;
}

/* ── Footer de la card ── */
.RegisterEmpresa_cardFooter__HZtK8 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 32px;
}

.RegisterEmpresa_cardFooterRight__sBnke {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ── Botones ── */
.RegisterEmpresa_btnBack__DQQT3 {
  padding: 10px 22px;
  border: 1.5px solid #d0d5dd;
  border-radius: 8px;
  background: transparent;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.2s;
}

.RegisterEmpresa_btnBack__DQQT3:hover {
  border-color: #1a3a5c;
  color: #1a3a5c;
}

.RegisterEmpresa_btnNext__Et0BA {
  padding: 10px 28px;
  background: #1a3a5c;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.RegisterEmpresa_btnNext__Et0BA:hover {
  background: #142e4a;
}

.RegisterEmpresa_btnSubmit__GUv64 {
  padding: 10px 28px;
  background: #2db899;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s;
}

.RegisterEmpresa_btnSubmit__GUv64:hover {
  background: #25a085;
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .RegisterEmpresa_pageHeader__uK0dP {
    padding: 20px 20px 16px;
  }

  .RegisterEmpresa_formGrid__UmiUb {
    grid-template-columns: repeat(2, 1fr);
  }

  .RegisterEmpresa_card__xc729 {
    padding: 24px 20px;
  }

  .RegisterEmpresa_stepLine__MPxiZ {
    width: 40px;
  }
}

@media (max-width: 500px) {
  .RegisterEmpresa_formGrid__UmiUb,
  .RegisterEmpresa_formGrid2__2\\+5BX {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/RegisterEmpresa/RegisterEmpresa.module.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B,iBAAiB;AACjB;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,aAAa;AACf;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/* RegisterEmpresa.module.css */\n\n/* ── Página ── */\n.page {\n  min-height: 100vh;\n  background-color: #f0f4f8;\n  padding-top: 64px;\n}\n\n/* ── Header superior ── */\n.pageHeader {\n  background: #ffffff;\n  border-bottom: 1px solid #e4e7ec;\n  padding: 16px 20px 16px;\n}\n\n.headerInner {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.breadcrumb {\n  font-size: 13px;\n  color: #98a2b3;\n  margin-bottom: 10px;\n}\n\n.breadcrumb a {\n  color: #98a2b3;\n  text-decoration: none;\n}\n\n.breadcrumb span {\n  color: #344054;\n  font-weight: 500;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n}\n\n.headerLeft h1 {\n  font-size: 2rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin: 0 0 4px;\n}\n\n.headerLeft p {\n  font-size: 14px;\n  color: #667085;\n  margin: 0;\n}\n\n.loginHint {\n  font-size: 14px;\n  color: #667085;\n  white-space: nowrap;\n}\n\n.loginHint a {\n  color: #1a3a5c;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.loginHint a:hover {\n  text-decoration: underline;\n}\n\n/* ── Stepper ── */\n.stepper {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-top: 24px;\n}\n\n.stepItem {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #98a2b3;\n  font-weight: 500;\n}\n\n.stepItem.active {\n  color: #1a3a5c;\n  font-weight: 600;\n}\n\n.stepCircle {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  border: 2px solid #d0d5dd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #98a2b3;\n  background: #fff;\n  flex-shrink: 0;\n}\n\n.stepItem.active .stepCircle,\n.stepItem.done .stepCircle {\n  background: #2db899;\n  border-color: #2db899;\n  color: #fff;\n}\n\n.stepLine {\n  width: 80px;\n  height: 2px;\n  background: #d0d5dd;\n  margin: 0 8px;\n}\n\n/* ── Contenido central ── */\n.content {\n  max-width: 900px;\n  margin: 40px auto;\n  padding: 0 20px;\n  box-sizing: border-box;\n}\n\n/* ── Card del formulario ── */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);\n  padding: 36px 40px;\n  box-sizing: border-box;\n}\n\n.stepLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  color: #2db899;\n  margin-bottom: 6px;\n}\n\n.cardTitle {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #1a3a5c;\n  margin-bottom: 4px;\n}\n\n.cardSubtitle {\n  font-size: 13px;\n  color: #667085;\n  margin-bottom: 28px;\n}\n\n/* ── Grid del formulario ── */\n.formGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 18px 16px;\n  margin-bottom: 28px;\n}\n\n.formGrid2 {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 18px 16px;\n  margin-bottom: 28px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.fieldFull {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.label {\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.8px;\n  text-transform: uppercase;\n  color: #667085;\n}\n\n.input {\n  height: 40px;\n  padding: 0 12px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  font-size: 14px;\n  color: #344054;\n  background: #ffffff;\n  outline: none;\n  width: 100%;\n  box-sizing: border-box;\n  transition: border-color 0.2s;\n  font-family: inherit;\n}\n\n.input:focus {\n  border-color: #1a3a5c;\n}\n\n.input::placeholder {\n  color: #b0b8c4;\n}\n\n/* ── Nota obligatorios ── */\n.required {\n  font-size: 12px;\n  color: #98a2b3;\n  margin-bottom: 28px;\n}\n\n/* ── Checkbox ── */\n.checkRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: #344054;\n}\n\n.checkRow input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: #2db899;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.checkRow a {\n  color: #2db899;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n/* ── Footer de la card ── */\n.cardFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 32px;\n}\n\n.cardFooterRight {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* ── Botones ── */\n.btnBack {\n  padding: 10px 22px;\n  border: 1.5px solid #d0d5dd;\n  border-radius: 8px;\n  background: transparent;\n  color: #344054;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: border-color 0.2s;\n}\n\n.btnBack:hover {\n  border-color: #1a3a5c;\n  color: #1a3a5c;\n}\n\n.btnNext {\n  padding: 10px 28px;\n  background: #1a3a5c;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnNext:hover {\n  background: #142e4a;\n}\n\n.btnSubmit {\n  padding: 10px 28px;\n  background: #2db899;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  transition: background-color 0.2s;\n}\n\n.btnSubmit:hover {\n  background: #25a085;\n}\n\n/* ── Responsive ── */\n@media (max-width: 768px) {\n  .pageHeader {\n    padding: 20px 20px 16px;\n  }\n\n  .formGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .card {\n    padding: 24px 20px;\n  }\n\n  .stepLine {\n    width: 40px;\n  }\n}\n\n@media (max-width: 500px) {\n  .formGrid,\n  .formGrid2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `RegisterEmpresa_page__cPRB5`,
	"pageHeader": `RegisterEmpresa_pageHeader__uK0dP`,
	"headerInner": `RegisterEmpresa_headerInner__M9f45`,
	"breadcrumb": `RegisterEmpresa_breadcrumb__yNe9f`,
	"headerRow": `RegisterEmpresa_headerRow__V4WPv`,
	"headerLeft": `RegisterEmpresa_headerLeft__u2wiS`,
	"loginHint": `RegisterEmpresa_loginHint__JV92z`,
	"stepper": `RegisterEmpresa_stepper__jn-th`,
	"stepItem": `RegisterEmpresa_stepItem__PM8Eb`,
	"active": `RegisterEmpresa_active__NtK5k`,
	"stepCircle": `RegisterEmpresa_stepCircle__GPQNC`,
	"done": `RegisterEmpresa_done__Btv-7`,
	"stepLine": `RegisterEmpresa_stepLine__MPxiZ`,
	"content": `RegisterEmpresa_content__U7hVA`,
	"card": `RegisterEmpresa_card__xc729`,
	"stepLabel": `RegisterEmpresa_stepLabel__YjZU7`,
	"cardTitle": `RegisterEmpresa_cardTitle__9Hho+`,
	"cardSubtitle": `RegisterEmpresa_cardSubtitle__fT-Qc`,
	"formGrid": `RegisterEmpresa_formGrid__UmiUb`,
	"formGrid2": `RegisterEmpresa_formGrid2__2+5BX`,
	"field": `RegisterEmpresa_field__5dRL-`,
	"fieldFull": `RegisterEmpresa_fieldFull__NCfXd`,
	"label": `RegisterEmpresa_label__mAIss`,
	"input": `RegisterEmpresa_input__aB2MZ`,
	"required": `RegisterEmpresa_required__SNnlZ`,
	"checkRow": `RegisterEmpresa_checkRow__9J1DJ`,
	"cardFooter": `RegisterEmpresa_cardFooter__HZtK8`,
	"cardFooterRight": `RegisterEmpresa_cardFooterRight__sBnke`,
	"btnBack": `RegisterEmpresa_btnBack__DQQT3`,
	"btnNext": `RegisterEmpresa_btnNext__Et0BA`,
	"btnSubmit": `RegisterEmpresa_btnSubmit__GUv64`
};
export default ___CSS_LOADER_EXPORT___;
